import * as Yup from 'yup';
import dayjs from 'dayjs';
import { SUBSCRIBE_OPTION } from '../constants';

/**
 * 实际余量查询表单默认值
 */
export const defaultQueryInfo: DefaultQueryInfo = {
  option_id: SUBSCRIBE_OPTION.LOUNGE,
  date: dayjs().format('YYYY-MM-DD'),
};

/**
 * 实际余量查询
 */
export interface DefaultQueryInfo {
  /**
   * 服务项目id
   */
  option_id: number;
  /**
   * 日期
   */
  date: string;
}

/**
 * 实际余量查询表单校验
 */
export const marginQuerySchema = Yup.object({
  option_id: Yup.number().typeError('请选择服务类型').required('请选择服务类型'),
  date: Yup.string().ensure().required('请选择日期'),
});
